module.exports = __webpack_public_path__ + "static/media/adults-obese.d1feb804.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/adults-obese.svg
// module id = 880
// module chunks = 0 1